import { Gerrit } from 'logos';
import { DialogTitleWithIcon } from 'shared/MultiStepDialog';
import { TitleProps } from '../types';

export const Title = ({ text }: TitleProps) => {
  return (
    <DialogTitleWithIcon text={text}>
      <Gerrit size={24} />
    </DialogTitleWithIcon>
  );
};
